<template lang="pug">
  div(ref="profileV2DraggableAddressFields")
    div(v-for="(field, fieldIndex) in fields")
      v-layout(column).pl-1
        field-value(
          v-for="(address, index) in field.fields"
          is-profile-v2
          :key="address.column_name"
          :column-name="address.column_name"
          :field-name="address.label"
          :field-type="address.type"
          :dropdown-items="address.options"
          :field-label="address.label"
          v-model="address.value"
          full-width
          @input='onChange($event, address.column_name, address.label, fieldIndex)'
          :field-labels="labels"
          isAddressField
        )
          template(v-if="index === 0" slot="action")
            v-btn(icon rounded small @click="onDelete({id: field.address_id})")
              v-icon(color="grey darken-1" small) delete
      v-divider.divider
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import FieldValueV2 from './FieldValueV2';
import FieldValue from '../../profile/FieldValue';
import ContactInfo from '@/Contacts/mixins/ContactInfo';

const { mapGetters: mapTeamMembersGetters } = createNamespacedHelpers('teamMembers');

export default {
  components: {
    FieldValueV2,
    FieldValue,
  },
  props: {
    card: {
      required: true,
      default: {}
    },
    newAddress: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ContactInfo],
  data() {
    return {
      isDeleteIconClicked: false,
    }
  },
  mounted() {
    if(this.newAddress) {
      this.$refs.profileV2DraggableAddressFields.scrollIntoView(false);
    }
  },
  updated() {
    if(this.isDeleteIconClicked) {
      this.isDeleteIconClicked = false;
      return;
    }
    if(this.newAddress) {
      this.$refs.profileV2DraggableAddressFields.scrollIntoView(false);
    }
  },
  computed: {
    ...mapTeamMembersGetters(['teamMembersInfo']),
    fields() {
      return this.card.fields;
    },
  },
  methods: {
    onChange(newValue, id, attrName, fieldIndex) {
      const address = this.fields[fieldIndex];
      const value = { [id]: newValue };
      value["id"] = address.address_id;
      const fieldValue = {
        type: attrName,
        name: this.card.card_id,
        isAddress: true,
        id: value.id,
      }
      this.$emit("input", value, fieldValue);
    },
    onDelete(fieldToDelete) {
      this.isDeleteIconClicked = true;
      this.$emit('delete', fieldToDelete);
    },
  } 
}
</script>

<style lang="scss" scoped>
  .remove-icon {
    color: #757575;
  }
  .divider {
    padding: 2% 0% 3% 0%;
  }
</style>
